import { createFileRoute } from '@tanstack/react-router'

import { EntryScreen, PasswordField } from '@/components/entry'
import { AppButton, SectionLabel } from '@/components/shared'
import { ACTIVATION } from '@/mocks/entry/aktivace'

export const Route = createFileRoute('/aktivace')({
  head: () => ({ meta: [{ title: 'Aktivace účtu · Aplikace Bitez' }] }),
  component: Aktivace,
})

/**
 * The very first screen of the product — arrived at from the activation e-mail
 * (spec §2.3). Everything administrative is already filled in by the manager,
 * so there is exactly one thing to do here, and the screen is built around it:
 * the venue's own name in Champ, the e-mail we already know as a plain fact,
 * one field, one button.
 */
function Aktivace() {
  return (
    <EntryScreen sticker="hand-peace">
      <SectionLabel>Aktivace účtu</SectionLabel>
      <h1 className="font-display mt-2 text-3xl leading-[0.88] uppercase">{ACTIVATION.venue}</h1>
      <p className="mt-3 text-sm leading-relaxed text-ink/60">
        Účet je připravený. Zvolte si heslo a pustíme se do toho.
      </p>

      {/* The e-mail is a FACT, not a field — we know it, and re-typing it would
          be the first thing we ask them to do for nothing. */}
      <p className="mt-7 flex items-baseline gap-1.5 text-sm">
        <span className="text-ink/70">E-mail</span>
        <span aria-hidden className="min-w-4 flex-1 border-b-2 border-dotted border-ink/15" />
        <span className="truncate font-bold">{ACTIVATION.email}</span>
      </p>

      <div className="mt-5">
        <PasswordField label="Vaše heslo" hint="Aspoň 8 znaků." />
      </div>

      <AppButton size="lg" href="/onboarding/vitejte" className="mt-7 w-full">
        Pokračovat
      </AppButton>

      <p className="mt-5 text-center text-[10px] leading-relaxed font-semibold text-ink/40">
        Nejste to vy?{' '}
        <button
          type="button"
          className="cursor-pointer text-ink/60 underline-offset-4 hover:text-brand hover:underline"
        >
          Ozvěte se nám
        </button>
      </p>
    </EntryScreen>
  )
}
